import _regeneratorRuntime from "/Users/joe/Projects/onthewall-v2-leeungno/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
var _marked = /*#__PURE__*/ _regeneratorRuntime().mark(syncGlobalData), _marked2 = /*#__PURE__*/ _regeneratorRuntime().mark(getGlobalData), _marked3 = /*#__PURE__*/ _regeneratorRuntime().mark(updateGlobalData), _marked4 = /*#__PURE__*/ _regeneratorRuntime().mark(watchSyncGlobalData), _marked5 = /*#__PURE__*/ _regeneratorRuntime().mark(watchGetGlobalData), _marked6 = /*#__PURE__*/ _regeneratorRuntime().mark(watchUpdateGlobalData), _marked7 = /*#__PURE__*/ _regeneratorRuntime().mark(globalSaga);
import { all, fork, put, call, takeEvery, take, cancel } from "redux-saga/effects";
import { actions } from "../reducers/global";
import { GLOBAL_DATA_KEY } from "../constants";
import { rsfDB } from "../lib/firebase"; // call은 동기, fork는 비동기 요청
function syncGlobalData() { var task; return _regeneratorRuntime().wrap(function syncGlobalData$(_context) { while (1)
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return fork(rsfDB.syncDocument, "Global/".concat(GLOBAL_DATA_KEY), { successActionCreator: function successActionCreator(data) { return { type: actions.SYNC_GLOBAL_DATA_SUCCESS, data: data.data() }; }, failureActionCreator: function failureActionCreator(err) { return { type: actions.SYNC_GLOBAL_DATA_FAILURE, err: err.message }; } });
        case 2:
            task = _context.sent;
            _context.next = 5;
            return take(actions.SYNC_GLOBAL_DATA_DONE);
        case 5:
            _context.next = 7;
            return cancel(task);
        case 7:
        case "end": return _context.stop();
    } }, _marked); }
function getGlobalData(action) { var exhibitionId, _exhibitionSnapshot$d, _exhibitionSnapshot$d2, globalSnapshot, exhibitionSnapshot; return _regeneratorRuntime().wrap(function getGlobalData$(_context2) { while (1)
    switch (_context2.prev = _context2.next) {
        case 0:
            exhibitionId = action.exhibitionId;
            _context2.prev = 1;
            _context2.next = 4;
            return call(rsfDB.getDocument, "Global/".concat(GLOBAL_DATA_KEY));
        case 4:
            globalSnapshot = _context2.sent;
            _context2.next = 7;
            return call(rsfDB.getDocument, "Exhibition/".concat(exhibitionId));
        case 7:
            exhibitionSnapshot = _context2.sent;
            _context2.next = 10;
            return put({ type: actions.GET_GLOBAL_DATA_SUCCESS, globalData: globalSnapshot.data(), hasMenuButton: exhibitionSnapshot.data().hasMenuButton, isCustomized: exhibitionSnapshot.data().isCustomized, hasTitle: exhibitionSnapshot.data().hasTitle, hasView: exhibitionSnapshot.data().hasView, hasSize: exhibitionSnapshot.data().hasSize, hasTag: exhibitionSnapshot.data().hasTag, hasMenuOptions: exhibitionSnapshot.data().hasMenuOptions, globalOption: exhibitionSnapshot.data().defaultGlobalOptions, queryOption: exhibitionSnapshot.data().queryOption, isPlatform: exhibitionSnapshot.data().isPlatform, plan: exhibitionSnapshot.data().plan, expiredAt: ((_exhibitionSnapshot$d = exhibitionSnapshot.data().expiredAt) === null || _exhibitionSnapshot$d === void 0 ? void 0 : _exhibitionSnapshot$d.seconds) * 1000, paidAt: ((_exhibitionSnapshot$d2 = exhibitionSnapshot.data().paidAt) === null || _exhibitionSnapshot$d2 === void 0 ? void 0 : _exhibitionSnapshot$d2.seconds) * 1000 });
        case 10:
            _context2.next = 16;
            break;
        case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](1);
            _context2.next = 16;
            return put({ type: actions.GET_GLOBAL_DATA_FAILURE, error: _context2.t0.message });
        case 16:
        case "end": return _context2.stop();
    } }, _marked2, null, [[1, 12]]); }
function updateGlobalData(action) { var target, value; return _regeneratorRuntime().wrap(function updateGlobalData$(_context3) { while (1)
    switch (_context3.prev = _context3.next) {
        case 0:
            target = action.target, value = action.value;
            _context3.prev = 1;
            _context3.next = 4;
            return call(rsfDB.updateDocument, "Global/".concat(GLOBAL_DATA_KEY), target, value);
        case 4:
            _context3.next = 6;
            return put({ type: actions.UPDATE_GLOBAL_DATA_SUCCESS });
        case 6:
            _context3.next = 12;
            break;
        case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            _context3.next = 12;
            return put({ type: actions.UPDATE_GLOBAL_DATA_FAILURE, error: _context3.t0.message });
        case 12:
        case "end": return _context3.stop();
    } }, _marked3, null, [[1, 8]]); }
function watchSyncGlobalData() { return _regeneratorRuntime().wrap(function watchSyncGlobalData$(_context4) { while (1)
    switch (_context4.prev = _context4.next) {
        case 0:
            _context4.next = 2;
            return takeEvery(actions.SYNC_GLOBAL_DATA_REQUEST, syncGlobalData);
        case 2:
        case "end": return _context4.stop();
    } }, _marked4); }
function watchGetGlobalData() { return _regeneratorRuntime().wrap(function watchGetGlobalData$(_context5) { while (1)
    switch (_context5.prev = _context5.next) {
        case 0:
            _context5.next = 2;
            return takeEvery(actions.GET_GLOBAL_DATA_REQUEST, getGlobalData);
        case 2:
        case "end": return _context5.stop();
    } }, _marked5); }
function watchUpdateGlobalData() { return _regeneratorRuntime().wrap(function watchUpdateGlobalData$(_context6) { while (1)
    switch (_context6.prev = _context6.next) {
        case 0:
            _context6.next = 2;
            return takeEvery(actions.UPDATE_GLOBAL_DATA_REQUEST, updateGlobalData);
        case 2:
        case "end": return _context6.stop();
    } }, _marked6); }
export default function globalSaga() { return _regeneratorRuntime().wrap(function globalSaga$(_context7) { while (1)
    switch (_context7.prev = _context7.next) {
        case 0:
            _context7.next = 2;
            return all([fork(watchSyncGlobalData), fork(watchUpdateGlobalData), fork(watchGetGlobalData)]);
        case 2:
        case "end": return _context7.stop();
    } }, _marked7); }
